import { gql } from "@apollo/client";

export default gql`
  mutation reorderTopicNewPageMutation(
    $afterTopicId: Int
    $beforeTopicId: Int
    $topicId: Int!
    $meetingId: Int
  ) {
    reorderTopic(
      afterTopicId: $afterTopicId
      beforeTopicId: $beforeTopicId
      topicId: $topicId
      meetingId: $meetingId
    ) {
      topic {
        id
      }
      afterTopic {
        id
      }
      beforeTopic {
        id
      }
      meeting {
        id
      }
    }
  }
`;
